import { combine, withCallbacks, withContext } from 'react-hooks-combine'
import { withFormModel } from 'shared/hooks'
import { ServicesContext } from 'services/context'
import { spec, validators } from 'utils/validation'

import EditBeneficiaryFormComponent from './component'
import { formatCategories, formatSubcategories } from './helpers'
import { toBeneficiaryModel } from './mapping'

const { any, string } = validators

export const EditBeneficiaryForm = combine(
  withContext(
    'taxonomyService',
    ServicesContext,
    ({ taxonomyService }) => taxonomyService
  ),

  withContext(
    'adminMemberService',
    ServicesContext,
    ({ adminMemberService }) => adminMemberService
  ),

  withFormModel(
    (_state, { initialValues = {} }) => {
      const formattedCountry = initialValues.address?.country
        ? { id: '', name: initialValues.address.country }
        : ''

      const config = {
        beneficiaryName: {
          alias: 'Beneficiary name',
          initialValue: initialValues.beneficiaryName,
          spec: spec.flow(string.isNotEmpty, any.required),
        },

        email: {
          initialValue: initialValues.email || '',
          spec: spec.flow(string.isNotEmpty, string.isEmail, any.required),
        },

        country: {
          alias: 'country',
          initialValue: formattedCountry,
          spec: spec.flow(),
        },

        jurisdiction: {
          initialValue: initialValues.jurisdiction || '',
          spec: spec.flow(any.required),
        },

        categories: {
          initialValue: formatCategories(initialValues.category) || [],
          spec: spec.flow(any.required),
        },

        subCategories: {
          initialValue: formatSubcategories(initialValues.subCategory) || [],
          spec: spec.flow(any.required),
        },

        website: {
          initialValue: initialValues.website,
          spec: spec.flow(),
        },

        logo: {
          initialValue: initialValues.logo || '',
          spec: spec.flow(),
        },

        id: {
          initialValue: initialValues.id || '',
          spec: spec.flow(any.required),
        },

        active: {
          initialValue: initialValues.active || false,
          spec: spec.flow(any.required),
        },

        marketingPromotion: {
          initialValue: initialValues.marketingPromotion || false,
          spec: spec.flow(any.required),
        },
      }

      if (!initialValues.id) {
        config.password = spec.flow(string.isNotEmpty, any.required)
      }
      return config
    },
    { id: 'beneficiary-edit-form' }
  ),

  withCallbacks(
    {
      getOptionLabel:
        () =>
          ({ name }) =>
            name,
      getOptionValue:
        () =>
          ({ id }) =>
            id,

      loadJurisdictions:
        ({ taxonomyService }) =>
          (search = '') =>
            taxonomyService.queryJurisdictions({ search }),

      loadCategories:
        ({ taxonomyService }) =>
          () =>
            taxonomyService.queryBeneficiaryCategories().then(formatCategories),

      loadSubcategories:
        ({ taxonomyService }) =>
          () =>
            taxonomyService
              .queryBeneficiarySubcategories()
              .then(formatSubcategories),

      onSubmitRequest: {
        deps: ['onSubmit'],
        func:
          (_state, { onSubmit, initialValues }) =>
            (form) => {
              const mappedData = toBeneficiaryModel(form)
              const countryName = form.country ? form.country.name : undefined
              return onSubmit(
                { ...mappedData, address: { country: countryName } },
                initialValues
              )
            },
      },
    },
    []
  )
)(EditBeneficiaryFormComponent)
